module.exports = "/images/ag.svg?88c99df859659269d4e2a0f33ff014b2";